import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedCalendar = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="calendar" size="100%" color={stroke ?? color} />
);

export { LineRoundedCalendar };
